/**
 * Adapter mapping the API key status response to a flat view model for the
 * Manage Account page's API key card.
 */

import type { RescueApiKeyState, RescueApiKeyStatusData } from './apiKeyQueries';

const MASKED_KEY_PREFIX = `fi_rescue_${'•'.repeat(8)}`;

export interface RescueApiKeyView {
  state: RescueApiKeyState;
  /** Masked display form of the active key, e.g. `fi_rescue_••••••••Ab12`. Null unless ACTIVE. */
  maskedKey: string | null;
  createdAt: string | null;
  lastUsedAt: string | null;
  rateLimitReqPerMin: number | null;
}

export function adaptApiKeyStatus(data: RescueApiKeyStatusData | undefined): RescueApiKeyView | null {
  const status = data?.rescueApiKeyStatus;
  if (!status) {
    return null;
  }
  const apiKey = status.state === 'ACTIVE' ? status.apiKey : null;
  return {
    state: status.state,
    maskedKey: apiKey ? `${MASKED_KEY_PREFIX}${apiKey.keySuffix}` : null,
    createdAt: apiKey?.createdAt ?? null,
    lastUsedAt: apiKey?.lastUsedAt ?? null,
    rateLimitReqPerMin: apiKey?.rateLimitReqPerMin ?? null,
  };
}
